import { useContext } from 'react';

import { AppContext, AppContextType } from '../context/AppContextProvider';

// TODO: See if we can lazysget the values on first useContext call
export const useAppContext = () => useContext(AppContext) as AppContextType;
